import { render, staticRenderFns } from "./PrinterGroupEdit.vue?vue&type=template&id=944f4134&scoped=true"
import script from "./PrinterGroupEdit.vue?vue&type=script&lang=js"
export * from "./PrinterGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./PrinterGroupEdit.vue?vue&type=style&index=0&id=944f4134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944f4134",
  null
  
)

export default component.exports